<template>
  <b-modal
    id="editExamModal"
    size="lg"
    :title="title"
    @ok="onSave"
    @show="updateData"
  >
    <b-form-group label="Название">
      <b-form-input
        required
        v-model="formData.name"
      />
    </b-form-group>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button @click="ok" variant="primary" :disabled="isDisabled">
        Сохранить
      </b-button>
      <b-button @click="cancel" variant="outline-primary">
        Отмена
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'EditExamsModal',
  props: {
    editData: {
      type: Object,
      default: null
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.updateData()
      }
    }
  },
  data() {
    return {
      title: '',
      addTitle: 'Добавление предмета ЕГЭ',
      editTitle: 'Редактирование предмета ЕГЭ',
      formData: {
        id: null,
        name: ''
      }
    }
  },
  computed: {
    isDisabled() {
      return !(this.formData && this.formData.name)
    }
  },
  methods: {
    updateData() {
      this.formData = this.editData || this.clearData()
      this.title = this.editData ? this.editTitle : this.addTitle
    },
    onSave() {
      this.$emit('save', this.formData)
    },
    clearData() {
      return {
        id: null,
        name: ''
      }
    }
  }
}
</script>

<style scoped>

</style>
